import { AfterViewInit, Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { ISelectedContract, LoggedInUserSettings } from 'src/app/core/services/settings/logged-in-user-settings';
import { UserClaims } from 'src/app/model/okta/userClaims';
import { ADPResourceService } from 'digital-core';
declare var bootstrap: any;

@Component({
  selector: 'app-get-started-modal',
  templateUrl: './get-started-modal.component.html',
  styleUrls: ['./get-started-modal.component.scss'],
})
export class GetStartedModalComponent implements OnInit, AfterViewInit {
  @ViewChild('tutorialCarousel') tutorialCarousel: any;
  tutorialPanels: string[];

  constructor(
    public dialogRef: MatDialogRef<GetStartedModalComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
    private loggedInUserSettings: LoggedInUserSettings,
    private googleAnalyticsService: GoogleAnalyticsService,
    private resourceService: ADPResourceService
  ) {}

  ngOnInit(): void {
    const joined$ = combineLatest([this.loggedInUserSettings.$selectedContract, this.loggedInUserSettings.$userClaims]).pipe(
      filter(([a, b]) => a !== null && b !== null)
    );

    joined$.subscribe(([selectedContract, userClaims]: [ISelectedContract, UserClaims]) => {
      const isUserPrimary = this.googleAnalyticsService.isUserPrimary(selectedContract, userClaims);
      const isSPOEEnabled: boolean = this.resourceService.isPortalSettingTrue("Global_SPOE_Enabled");

      if (selectedContract.isPTPO) {
        if (isUserPrimary) {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_PTP_Primary')?.split(';');
        } else {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_PTP_Secondary')?.split(';');
        }
      }
      else if(isSPOEEnabled) {
        if (isUserPrimary) {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_SPOE_Primary')?.split(';');
        } else {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_SPOE_Secondary')?.split(';');
        }
      }
      else {
        if (isUserPrimary) {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_Primary')?.split(';');
        } else {
          this.tutorialPanels = this.getSetting('Tutorial_Panels_Secondary')?.split(';');
        }
      }
    });
  }

  ngAfterViewInit(): void {
    const carousel = new bootstrap.Carousel(this.tutorialCarousel.nativeElement, {
      wrap: true,
      touch: true,
    });
  }

  getSetting(name: string): string {
    return this.resourceService.getPortalSetting(name)?.Value;
  }

  closeModal() {
    this.dialogRef.close();
  }
}
